<template>
  <vx-card class="upgrade-list vs-space-table">
    <paging-list
      :data="list"
      :total="total"
      :limit="query.limit"
      :page="query.page"
      @pageChange="onPageChange"
    >
      <div slot="header" class="top w-full">
        <vx-form class="vx-row">
          <form-item label="搜索" class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" placeholder="输入订单号、商品标题" v-model="query.keyword" @keypress.enter="fetchList(1)"/>
          </form-item>
          <form-item label="订单状态" class="vx-col sm:w-1/3 w-full mb-2">
            <v-select placeholder="全部" :options="statusOpts" v-model="query.status" :reduce="p => p.id"
                      @change="fetchList(1)"></v-select>
          </form-item>
          <form-item :label="$acl.check('order_admin') ? '用户筛选' : '客户筛选'" class="vx-col sm:w-1/3 w-full mb-2" v-if="$acl.check('customer_list')">
            <v-select placeholder="全部" :options="$s.user.customersAndMe()" label="userName" v-model="query.uid" :reduce="p => p.uid">
              <template v-slot:option="user">
                <span v-if="user.uid == $s.auth.user.uid">(我)</span>{{user.nickName}}[{{user.userName}}]【{{user.name}}】
              </template>
            </v-select>
          </form-item>
          <form-item class="vx-col sm:w-1/3 w-full mb-2">
            <vs-button class="mr-3 mb-2" @click="fetchList(1)">
              查询
            </vs-button>
          </form-item>
        </vx-form>
      </div>
      <template slot="thead">
        <vs-th class="whitespace-no-wrap">订单号</vs-th>
        <vs-th class="whitespace-no-wrap">标题</vs-th>
        <vs-th v-if="$acl.check('order_admin')">用户名</vs-th>
        <vs-th v-else-if="$acl.check('customer_list')">客户名</vs-th>
        <vs-th class="whitespace-no-wrap">数量</vs-th>
        <vs-th class="whitespace-no-wrap">印刷服务</vs-th>
        <vs-th class="whitespace-no-wrap">标签尺寸</vs-th>
        <vs-th>收货信息</vs-th>
        <vs-th class="whitespace-no-wrap">订单状态</vs-th>
        <vs-th>价格</vs-th>
        <vs-th>下单时间</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="whitespace-no-wrap">{{tr.orderid}}</vs-td>
          <vs-td style="min-width: 200px"><router-link :to="'/product/edit/' + tr.productID" title="点击查看并编辑商品">{{tr.title}}</router-link></vs-td>
          <vs-td v-if="$acl.check('order_admin', 'customer_list')">{{tr.nickName}} [{{tr.userName}}]</vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.number}}</vs-td>
          <vs-td>{{tr.printing ? '需要':'不需要'}}</vs-td>
          <vs-td class="whitespace-no-wrap">
            <span v-if="tr.printing">
              {{getSticky(tr.stickyID).shape}} {{getSticky(tr.stickyID).width}}CM * {{getSticky(tr.stickyID).height}}CM
            </span>
            <span v-else>-</span>
          </vs-td>
          <vs-td v-if="tr.printing">
            <div class="whitespace-no-wrap">联系人: {{tr.contactName}}</div>
            <div class="whitespace-no-wrap">联系电话: {{tr.contactPhone}}</div>
            <div>收货地址: {{tr.address}}</div>
          </vs-td>
          <vs-td v-else>-</vs-td>
          <vs-td class="whitespace-no-wrap">{{orderStatus[tr.status]}}</vs-td>
          <vs-td class="whitespace-no-wrap"><span class="text-danger">￥{{(tr.amount / 100).toFixed(2)}}元</span></vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.createdAt| datetime}}</vs-td>
          <vs-td class="whitespace-no-wrap" v-if="$acl.check('order_admin')">
            <span class="text-primary mr-5" @click="$modal('orderDetail', {order: tr})">查看</span>
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5"
                  @click="$router.push('/order/edit/' + tr.orderid)">修改订单</span>
            <span v-if="tr.status == 20" class="text-primary cursor-pointer mr-5" @click="dealOrder(tr)">处理订单</span>
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5" @click="cancelOrder(tr)">取消订单</span>
            <a v-if="tr.status == 23" class="text-primary cursor-pointer mr-5" :href="downloadBase + tr.orderid"
               target="_blank" rel="noopener noreferrer">下载二维码</a>
          </vs-td>
          <vs-td class="whitespace-no-wrap" v-else>
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5"
                  @click="$router.push('/order/pay/' + tr.orderid)">立即支付</span>
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5" @click="cancelOrder(tr)">取消订单</span>
            <a v-if="tr.status == 23" :href="downloadBase + tr.orderid" class="mr-5" target="_blank"
               rel="noopener noreferrer">下载二维码</a>
          </vs-td>
        </vs-tr>
      </template>
    </paging-list>
  </vx-card>
</template>
<script>
  import _ from 'lodash'

  export default {
    data() {
      return {
        downloadBase: window.__CONFIG__.api + '/admin/v1/order/download/',
        list: [],
        total: 0,
        query: {
          time: [],
          keyword: '',
          limit: 20,
          page: 1,
          status: 0,
        },
      }
    },
    $computed: ['dict.orderStatus'],
    computed: {
      statusOpts() {
        return [
          ..._.map(this.orderStatus || {}, (v, k) => ({id: k, label: v}))
        ]
      }
    },

    mounted() {
      this.$s.user.getCompany()

      if (this.$acl.check('customer_list')) {
        this.$s.user.fetchCustomer()
      }
      this.query = {
        ...this.query,
        uid: Number(this.$route.query.customer || this.$route.query.uid || 0),
      }
      // this.fetchList(1)
    },
    methods: {
      getSticky(id) {
        return this.$s.getSticky(id)
      },
      onPageChange(p) {
        this.fetchList(p)
      },
      async fetchList(page) {
        if (page) {
          this.query.page = page
        }
        const q = {
          keyword: this.query.keyword,
          offset: (this.query.page - 1) * this.query.limit,
          limit: this.query.limit,
          status: this.query.status,
          uid: this.query.uid,
        }
        const {list, total} = await this.$s.order.list(q)
        this.list = list
        this.total = total
      },
      dealOrder(order) {
        this.$modal('dealOrder', {order})
      },
      cancelOrder(order) {
        this.$confirm({
          color: 'danger',
          title: '确定取消该订单？',
          text: '取消订单后，用户如果没支付，将会支付失败，如果支付成功，将会自动退还已支付款项到支付账户',
          accept: async () => {
            await this.$s.order.cancel(order.orderid)
            order.status = 25
          }
        })
      },
      userCancelOrder(order) {
        this.$confirm({
          color: 'danger',
          title: '确定取消该订单？',
          text: '取消订单后，改笔订单将作废',
          accept: async () => {
            await this.$s.order.cancel(order.orderid)
            order.status = 25
          }
        })
      }
    },
  }
</script>
